import React from 'react';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTag, faClockFour} from "@fortawesome/free-solid-svg-icons";

class CatDate extends React.Component {
    render() {
        const {current_category, current_date} = this.props;
        return (
            <table className="table">
                <tbody>
                <tr className="text-primary">
                    <td title="Kategoria sprawy">
                        <FontAwesomeIcon icon={faTag} className="fa-tag"></FontAwesomeIcon>&nbsp;{current_category}
                    </td>
                    <td title="Data wysłania" className="text-right">
                        <FontAwesomeIcon icon={faClockFour} className="fa-clock fa-xs" />&nbsp;{current_date}
                    </td>
                </tr>
                </tbody>
            </table>
        )
    }
}

export default CatDate;